const PROFILE_KEY = "contex_active_profile_id";

/**
 * The active profile lives in sessionStorage on purpose: a profile must be
 * picked once per tab and stays until the tab closes or the user switches.
 */
export const getActiveProfileId = () => {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(PROFILE_KEY);
};

export const setActiveProfileId = (profileId) => {
  if (typeof window === "undefined") return;
  if (profileId) sessionStorage.setItem(PROFILE_KEY, profileId);
  else sessionStorage.removeItem(PROFILE_KEY);
};

export const clearActiveProfileId = () => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(PROFILE_KEY);
  // Legacy value from when the selection was persisted across tabs.
  localStorage.removeItem(PROFILE_KEY);
};
